(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hyphaRPC", [], factory);
	else if(typeof exports === 'object')
		exports["hyphaRPC"] = factory();
	else
		root["hyphaRPC"] = factory();
})(window, function() {
return 